// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import get from 'lodash/get'
import { Query } from 'react-apollo'
import Typography from '@mui/material/Typography'
import { Paper } from '@mui/material'
import { i18n } from '../../index'
import Loader from '../../../common/loader/Loader'
import StationTable from './StationTable'
import { fetchStationList } from '../../station/stationQueries'
import css from './stationPage.css'

function StationListPage() {
  return (
    <div className={css.component}>
      <div className={css.top}>
        <Typography variant='h6'>{i18n.t('admin.stations.title.listPage')}</Typography>
      </div>
      <Query query={fetchStationList}>
        {({ loading, error, data }) => (
          <Loader
            {...{
              loading,
              error,
            }}
          >
            <Paper>
              <StationTable data={get(data, 'stations.edges', []).map(({ node }) => node)} />
            </Paper>
          </Loader>
        )}
      </Query>
    </div>
  )
}

export default StationListPage
